// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalUserAvatar-module-cc6d4d3a9c80492802b8","avatar":"ModalUserAvatar-module-c52f4bb1fea2ece1e418","visible":"ModalUserAvatar-module-b19332fbe3b62dcf9da3"};